import styled, { css } from 'styled-components'
import chroma from 'chroma-js'

import { mq, sizes } from '../../theme'
import A from '../A'

export const Container = styled.ul<{
  bgColor?: string
}>`
  ${({ theme }) => theme.fonts.HelveticaNeueMedium}
  display: flex;
  flex-flow: row nowrap;
  font-size: 1.4rem;
  list-style: none outside;
  line-height: 3rem;
`

export const BreadcrumbListItem = styled.li<{ bgColor?: string }>`
  position: relative;
  background-color: ${({ theme, bgColor }) =>
    bgColor ? bgColor : chroma(theme.colors.pureWhite).alpha(0.65).css()};
  line-height: 1.5;
  text-align: center;
  margin-bottom: 0.2rem;

  &:not(:last-child) {
    &::after {
      content: '>';
      margin: 0 1rem;
    }
  }
`

export const BreadcrumbLink = styled(A)<{
  hoverColor?: string
  bgColor?: string
}>`
  font-size: 1.4rem;
  font-weight: 500;
  padding: 0 0.2rem 0 0.4rem;
  color: inherit;
  &.is-link {
    text-decoration: underline;
    &:hover {
      text-decoration: none;
      color: ${({ hoverColor }) => hoverColor};
    }
    li:last-child & {
      text-decoration: none;
    }
  }
`

export const mobileBreadcrumbStyles = css`
  display: flex;
  background-color: ${({ theme }) => theme.colors.greyf5};
  flex-flow: row wrap;
  padding: 3rem calc(50vw - 20rem) 6rem;
  justify-content: center;
  margin: 0 auto;
  width: 100%;

  @media ${mq(sizes.desktop)} {
    display: none;
  }
`
